// Expense Approval Configuration
// Users in this list will need approval for their expenses

export const EXPENSE_APPROVAL_CONFIG = {
  // Email addresses that require approval for expenses
  // TO ADD MORE EMAILS: Simply add them to this array below
  restrictedEmails: [
    "angelankhowani@gmail.com",
    "kelvin.sokuni@ksm.co.zm",
    // Add more email addresses here as needed - Example:
    // 'john.doe@company.com',
    // 'jane.smith@company.com',
  ],

  // Transaction types that require approval
  restrictedTransactionTypes: ["Operational Cost"],

  // Minimum amount that triggers approval (optional)
  approvalThreshold: 0, // Set to 0 to require approval for all amounts

  // Administrator emails who can approve expenses
  approverEmails: [
    // Will be populated from user role = 'Administrator'
  ],
};

// Helper function to check if a user email requires approval
export const requiresApproval = (
  userEmail,
  transactionType = null,
  amount = 0
) => {
  // Check if email is in restricted list
  const emailRequiresApproval =
    EXPENSE_APPROVAL_CONFIG.restrictedEmails.includes(userEmail?.toLowerCase());

  // Check if transaction type requires approval (if specified)
  const typeRequiresApproval = transactionType
    ? EXPENSE_APPROVAL_CONFIG.restrictedTransactionTypes.includes(
        transactionType
      )
    : true;

  // Check if amount exceeds threshold
  const amountRequiresApproval =
    amount >= EXPENSE_APPROVAL_CONFIG.approvalThreshold;

  return (
    emailRequiresApproval && typeRequiresApproval && amountRequiresApproval
  );
};

// Helper function to check if a user can approve expenses
export const canApproveExpenses = (userRole) => {
  return userRole === "Administrator";
};
